export const isKakao = () => navigator.userAgent.includes('KAKAOTALK');
export const openDefaultBrowserInKakao = () => {
  if (!isKakao()) return;

  const targetUrl = window.location.href;
  location.href =
    'kakaotalk://web/openExternal?url=' + encodeURIComponent(targetUrl);
};
